import { createSelector } from '@reduxjs/toolkit'
import { mapping } from 'actions/mapping'
import { useState } from 'react'
import { useAppSelector } from 'shared/hooks'

import type { RootState } from '../../../redux/store'

import { appSelectors } from '../../../redux/reducers/app'

const selectCampaignsTeams = createSelector(
	(state: RootState) => state.campaignsTeams.campaignsTeams,
	mapping.campaignsForTable
)

// TODO: replace to TeamCampaignStatistics
export function useTempProps() {
	const campaignsTeams = useAppSelector(selectCampaignsTeams)
	const [loaderStatistics, setLoaderStatistics] = useState(false)
	const [orderby, setOrderby] = useState('created desc')

	const localAppProfile = useAppSelector(appSelectors.appProfile)

	return {
		campaignsTeams,
		loaderStatistics,
		localAppProfile,
		orderby,
		setLoaderStatistics,
		setOrderby
	}
}
